import { useMemo } from "react";

import { getInitialsFromFullName } from "../../../../constants/constants";
import { getLinkedFirm } from "../../../../sessionStorage/sessionStorage";
import { useGetUsersQuery } from "../../../../slices/UserSlice";
import { SelectOptionType } from "../../../../types/types";

export const useReminderLookups = () => {
  const orgId = getLinkedFirm()?.orgId || "";

  const { data: users, isFetching: isLoadingUsers } = useGetUsersQuery(orgId, {
    skip: !orgId,
  });

  const userOptions = useMemo<SelectOptionType[]>(() => {
    return (
      users?.map((item) => {
        const firstName = item?.userProfile?.firstName || "";
        const lastName = item?.userProfile?.lastName || "";
        const fullName = `${firstName} ${lastName}`.trim();

        return {
          label: fullName,
          value: `${item.id}`,
          avatar: getInitialsFromFullName(fullName),
          avatarCustomColor: item?.userProfile?.color,
        };
      }) || []
    );
  }, [users]);

  return {
    userOptions,
    isLoadingUsers,
  };
};
